<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :stripe="false"
      :selection="selection"
      search-btn-hide
      right-toolbar-hide
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:baseForm> </template>

      <template v-slot:tableColumn>
        <!-- #ifndef OPEN-SOURCE -->
        <el-table-column prop="sourcingStatus" :label="$t('SourcingDetails.form.status')" align="center"
          ><template slot-scope="scope">
            {{ $t(ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST.bjGet(scope.row.sourcingStatus)) }}
          </template></el-table-column
        >
        <!-- #endif -->
        <!-- <el-table-column prop="spuName" :label="$t('goodsPage.spuName')" />
        <el-table-column prop="spuCode" :label="$t('goodsPage.spuCode')" /> -->
        <el-table-column prop="skuName" :label="$t('SourcingDetails.form.SKU')" />
        <el-table-column prop="skuCode" :label="$t('SourcingDetails.form.SKUcode')" />
        <el-table-column prop="num" :label="$t('SourcingDetails.form.quantity')" />
        <el-table-column prop="giftFlag" align="center" :label="$t('SourcingDetails.form.Whether')">
          <template slot-scope="scope">
            <el-tag :type="scope.row.giftFlag ? 'success' : 'info'">{{
              $t(STATUS_YES_NUM.bjGet(!!scope.row.giftFlag))
            }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="stockWarehouseCode" :label="$t('SourcingDetails.form.warehouse')" width="212" />
        <el-table-column prop="stockWarehouseName" :label="$t('SourcingDetails.form.Shipment')" width="212" />
        <el-table-column prop="failReason" :label="$t('SourcingDetails.form.Failure')" />
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import { STATUS_YES_NUM, ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST } from '@/utils/constants';

export default {
  name: 'BusinessOrderPreemptDetailSkuLineList',
  components: {},
  mixins: [pageMiXin],
  props: ['orderId', 'hasBtn'],
  data() {
    return {
      sortTableByOptionName: true,

      STATUS_YES_NUM,
      ORDER_INTERNAL_LINE_SOURCE_STATUS_LIST,

      selection: false,
      queryApi: orderApi.getOrderSourcingSkuLineListByOrder,
      // 查询参数
      queryParams: {
        sourcingId: null,
        sourcingStatus: null,
        sourceStatus: null,
      },
      selectedRow: null,
    };
  },
  watch: {},
  created() {
    this.queryParams.sourcingId = this.orderId;
  },
  methods: {},
};
</script>
